import React, {useEffect, useState} from 'react';
import {AddNewDelegationModal} from '../components/Delegations/AddNewDelegationModal';
import {Flow, FlowFetchResponse} from '../_services/Flow';

type DelegationsProps = {};

type Delegation = {
    id: number;
    startDate: string;
    endDate: string;
    showOutOfOffice: boolean;
}

export const Delegations: React.FunctionComponent<DelegationsProps> = ({}) => {
    const [showNewDelegationModal, setShowNewDelegationModal] = useState<boolean>(false);
    const [delegations, setDelegations] = useState<Delegation[]>([]);
    const [delegationsListKey, setDelegationsListKey] = useState<number>(1);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [isDeleting, setIsDeleting] = useState<boolean>(false);

    useEffect(() => {
        Flow.getInstance().getUserDelegations()
            .then((response: FlowFetchResponse) => {
                if (response.ok) {
                    console.log(response.json);
                    setDelegations(response.json.delegations);
                } else {
                    throw Error(response?.json?.message || 'Error getting delegations');
                }
            })
            .catch((error: any) => {
                console.log(error?.message || error || 'Error getting delegations');
            })
            .finally(() => {

            });
    }, [delegationsListKey]);

    const handleRemoveDelegation = (delegationId: number) => {
        setErrorMessage('');
        setIsDeleting(true);

        Flow.getInstance().removeUserDelegation(delegationId)
            .then((response: FlowFetchResponse) => {
                if (response.ok) {
                    setDelegationsListKey(delegationsListKey + 1);
                } else {
                    throw new Error(response?.json?.message || 'Error removing delegation');
                }
            })
            .catch((error: any) => {
                setErrorMessage(error?.message || error || 'Error removing delegation');
            })
            .finally(() => {
                setIsDeleting(false);
            });
    };

    return (
        <div>
            {errorMessage && <div className="alert alert-danger"><p>{errorMessage}</p></div>}
            <h1 className={'abb-header'}>Manage Delegations</h1>
            <p>If you are going to be out of office or otherwise unable to action workflow entries assigned to you, you can
                assign a delegate to be assigned to workflow steps in your place. If you are unable to assign a delegate during
                you unavailability, you can still indicate the time you will be unavailable to let requestors know not
                to expect a response from you during this period</p>

            <div className="text-center">
                <button type="button"
                        className="btn btn-primary"
                        onClick={() => {
                            setShowNewDelegationModal(true);
                        }}
                >Add New Delegation
                </button>
            </div>

            <h3>Active and Upcoming Delegations</h3>

            {delegations && delegations.length > 0 ?
                <table className="table table-sm">
                    <thead>
                    <tr>
                        <th className="text-nowrap">Start Date</th>
                        <th className="text-nowrap">End Date</th>
                        <th style={{whiteSpace: 'nowrap'}}>Show OutOfOffice Status</th>
                        <th className="w-100">Workflow(s)</th>
                        <th/>
                    </tr>
                    </thead>
                    <tbody>
                    {delegations.map((delegation: Delegation) => (
                        <tr key={delegation.id}>
                            <td className="text-nowrap">{delegation.startDate}</td>
                            <td className="text-nowrap">{delegation.endDate}</td>
                            <td>{delegation.showOutOfOffice ? 'Yes' : 'No'}</td>
                            <td>
                                {delegation.delegations.length === 0 ?
                                    <em>None</em>
                                    :
                                    delegation.delegations.map((stepDelegation) => (
                                        <div key={stepDelegation.id} className="mb-2">
                                            <div>{stepDelegation?.workflow?.title}</div>
                                            <small className="d-block">
                                                <strong>
                                                    {stepDelegation.delegateType === 'step' && stepDelegation?.step?.name}
                                                    {stepDelegation.delegateType === 'manager' && 'Manager'}
                                                    {stepDelegation.delegateType === 'manual' && 'Manual'}
                                                </strong>
                                            </small>
                                            <small className="d-block">{stepDelegation.email}</small>
                                        </div>
                                    ))
                                }
                            </td>
                            <td>
                                <button type="button"
                                        className="btn btn-link"
                                        disabled={isDeleting}
                                        onClick={() => {
                                            handleRemoveDelegation(delegation.id);
                                        }}
                                >Remove
                                </button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                :
                <p><em>No active or upcoming delegations</em></p>
            }

            <AddNewDelegationModal
                show={showNewDelegationModal}
                hide={() => {
                    setShowNewDelegationModal(false);
                }}
                save={() => {
                    setDelegationsListKey(delegationsListKey + 1);
                }}
            />

        </div>
    )
}